import React, { useState } from 'react';
import {
  ReferenceManyField,
  Datagrid,
  Pagination,
  SimpleShowLayout,
  TextField,
  FunctionField,
  useNotify,
  useRecordContext,
  useRefresh,
} from 'react-admin';
import { Box, Button } from '@mui/material';
import IdField from 'components/IdField';
import PoolCreateEditModal from 'resources/pro_pools/PoolCreateEditModal';
import { formatSpecialtiesLabel } from 'resources/pro_pools/specialtiesDisplay.utils';

const PoolsTab = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();
  const location = useRecordContext();

  const handleSuccess = () => {
    setIsModalOpen(false);
    notify('Pool created successfully', { type: 'success' });
    refresh();
  };

  return (
    <SimpleShowLayout>
      <Box mb={2}>
        <Button variant="contained" size="small" onClick={() => setIsModalOpen(true)}>
          Create Pool
        </Button>
      </Box>
      <ReferenceManyField
        pagination={<Pagination />}
        label=""
        reference="Pool"
        target="search.location_id"
      >
        <Datagrid bulkActionButtons={false}>
          <IdField />
          <FunctionField
            label="Position(s)"
            render={(record) => record?.positions?.map((item) => item.display_name).join(', ')}
          />
          <FunctionField
            label="Specialties"
            render={(record) => formatSpecialtiesLabel(record?.specialties)}
          />
          <TextField
            label="Invites Pending"
            source="onboarding_status.not_accepted"
            sortable={false}
          />
          <TextField
            label="Pros in Credentialing"
            source="onboarding_status.credentialing"
            sortable={false}
          />
          <TextField
            label="Pros in Onboarding"
            source="onboarding_status.orientation"
            sortable={false}
          />
          <TextField
            label="Pros Ready to Work"
            source="onboarding_status.complete"
            sortable={false}
          />
        </Datagrid>
      </ReferenceManyField>
      <PoolCreateEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={handleSuccess}
        initialLocation={location?.id}
      />
    </SimpleShowLayout>
  );
};

export default React.memo(PoolsTab);
